import { render } from "./Christmas2024.vue?vue&type=template&id=36df546d"
import script from "./Christmas2024.vue?vue&type=script&lang=js"
export * from "./Christmas2024.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__